import { Utilities as U } from "@shared/utilities/utilities.model";

enum EExceptionGenerationPo {
CODE        = 'code',
TYPE        = 'type',
DESCRIPTION = 'description',
ID          = 'id',
}
export class ExceptionGenerationPo {
  [EExceptionGenerationPo.CODE]:         string = '';
  [EExceptionGenerationPo.TYPE]:         ETypeExceptionGenerationPo | string;
  [EExceptionGenerationPo.DESCRIPTION]:  string = '';
  [EExceptionGenerationPo.ID]:           string = '';

	constructor(model?: any) {
    
		if (U.isEmpty(model)) {
			return;
		}

    // model.code += 'a';

    if (!codeValidator) {
      throw new Error("Codice non valido - deve contenere solo numeri");
    }

    this.code =        model.code;
    this.type =        U.nullish(ETypeExceptionGenerationPo[model.type], null);
    this.description = model.description;
    this.id =          model.id;
  }

};

function codeValidator(val: string) {
  return /^\d+$/.test(val);
} 

export enum ETypeExceptionGenerationPo {
  TERMINATION_REASON = 'TERMINATION_REASON',
  SERVICE_POINT      = 'SERVICE_POINT',
  PRODUCT_ID         = 'PRODUCT_ID',
};
